<template>
  <div class="wrapper">
    <h1>Belegungen</h1>
    <p class="intro mt-2">Nachstehend können Sie die Belegungne entnehmen, pla pla</p>
    <div class="flex mt-6">
      <span class="rounded-full pl-1 bg-red-600"></span>
      <p class="ml-2">Die Hütte ist geschlossen.</p>
    </div>
    <div class="flex mt-3">
      <span class="rounded-full pl-1 bg-red-200"></span>
      <p class="ml-2">Die gesamte Hütte ist vermietet.</p>
    </div>
    <div class="flex mt-3">
      <span class="rounded-full pl-1 bg-orange-300"></span>
      <p class="ml-2">Einzelne Zimmer sind belegt.</p>
    </div>
    <ReservationsCalendar v-if="documents" :documents="documents" />
  </div>
</template>


<script>
import ReservationsCalendar from '../components/ReservationsCalendar.vue'

export default {
  name: 'Reservation',
  components: {
    ReservationsCalendar,
  },
  data() {
    return {
      documents: null,
    }
  },
  methods: {
    getContent() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at('document.type', 'reservation'))
        .then(response => {
          if (response) {
            this.documents = response.results
          }
        })
    },
  },
  created() {
    this.getContent()
  },
}
</script>
